import React, { useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { Row, Col, Table, Button, Modal, } from 'react-bootstrap';
import { BiRefresh, BiDownload } from 'react-icons/bi';
import 'datatables.net-dt/css/jquery.dataTables.min.css';
import 'datatables.net-dt/js/dataTables.dataTables.js';
import '../../../shared/Shared.css';
import $ from 'jquery';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import swal from 'sweetalert';
import { VedikaService } from '../../../services/VedikaService';
import LoadingSpinner from '../../../shared/LoadingSpinner';

const Billings = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [listBilling,setListBilling] = useState([]);
    const [showDeskripsi, setshowDeskripsi] = useState();
    const handleCloseDeskripsi = () => setshowDeskripsi(false);
    const [selectedData, setselectedData] = useState('');
    const [nilaiClaim, setnilaiClaim] = useState(null);

    const loadInit = async () => {
        setIsLoading(true)
        let param = { noregistrasi: $('#noRegistrasi').text(), ruangan: undefined };

        try {
            const promise1 = await VedikaService.getDetailTagihan2(param)
            const promise2 = await VedikaService.getNilaiClaim(`noregistrasifk=${$('#noRegistrasi').text()}`)
            const allPromise = await Promise.all([promise1, promise2]);
            setselectedData(allPromise[0].data)
            setListBilling(allPromise[0].data.details);
            setnilaiClaim(allPromise[1].data.data);
        } catch (error) {
            swal({
                title: error.code,
                text: error.message,
                icon: "error",
                button: "OK",
            })
                .then((val) => {
                });
        }finally{
            setIsLoading(false)
        }
    }
    const handleShowFile = (row) => {
        setshowDeskripsi(true);
        setTimeout(() => {
            $('#frameFile').attr("src", row.url);
        }, 2000);
    }

    const loadDtListBilling = () => {
        $('#dtListBilling').DataTable({
            data: listBilling,
            ordering: false,
            pageLength: 10,
            scrollCollapse: true,
            scrollY: '50vh',
            destroy: true,
            autoWidth: false,
            paging: false,
            // retrieve: true,
            columns: [
                {
                    targets: [0],
                    data: 'tglPelayanan',
                    width: '10%',
                },
                {
                    targets: [1],
                    data: 'ruangan',
                },
                {
                    targets: [2],
                    data: 'detailjenisproduk',
                },
                {
                    targets: [3],
                    data: 'dokter',
                    // data:null,
                    // createdCell:(td, cellData, rowData, row, col) => createRoot(td).render($('#dpjp').val())
                },
                {
                    targets: [4],
                    data: 'namaPelayanan',
                },
                {
                    targets: [5],
                    data: 'jumlah',
                },
                {
                    targets: [6],
                    data: 'harga',
                },
                {
                    targets: [6],
                    data: 'total',
                },
            ]
        })
    }

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            background: '#fff',
            borderColor: '#9e9e9e',
            minHeight: '30px',
            height: '30px',
            boxShadow: state.isFocused ? null : null,
        }),

        valueContainer: (provided, state) => ({
            ...provided,
            height: '30px',
            padding: '0 6px'
        }),

        input: (provided, state) => ({
            ...provided,
            margin: '0px',
        }),
        indicatorSeparator: state => ({
            display: 'none',
        }),
        indicatorsContainer: (provided, state) => ({
            ...provided,
            height: '30px',
        }),
    };

    useEffect(()=>{
        loadDtListBilling();
    },[listBilling])

    useEffect(() => {
        setTimeout(() => {
            loadInit()
        }, 1000);
    }, [])

    return (
        <React.Fragment>
            {isLoading ? (<LoadingSpinner />) : null}
            <Row>
                <Col md={10} className='text-center bg-success text-white'>
                    <h5>Billing</h5>
                </Col>
                <Col className='d-flex justify-content-center bg-warning'>
                    <div className="d-flex flex-row-reverse align-items-center bd-highlight">
                        <a href={`https://pelayanan.rsabhk.co.id/vedika/cetak/billing/${$('#norec').val()}`} style={{ textDecoration: 'none', color: 'black' }} target='_blank' download><BiDownload /> Download </a>
                    </div>
                </Col>
                <Col className='d-flex justify-content-center bg-light'>
                    <div className="d-flex flex-row-reverse bd-highlight">
                        <Button size='sm' variant='light' onClick={loadInit}><BiRefresh /> Refresh</Button>
                    </div>
                </Col>
            </Row>
            <Row className='pt-2'>
                <Col sm={3}>
                    <Row>
                        <Col sm={12}>
                            <p className='f7'><strong>Tanggal Masuk</strong><br />{selectedData ? selectedData.tglMasuk : ''}</p>
                        </Col>
                    </Row>
                </Col>
                <Col sm={3}>
                    <Row>
                        <Col sm={12}>
                            <p className='f7'><strong>Tanggal Pulang</strong><br />{selectedData ? selectedData.tglPulang : ''}</p>
                        </Col>
                    </Row>
                </Col>
                <Col sm={3}>
                    <Row>
                        <Col sm={12}>
                            <p className='f7'><strong>Ruangan Terakhir</strong><br />{selectedData ? selectedData.lastRuangan : ''}</p>
                        </Col>
                    </Row>
                </Col>
                <Col sm={3}>
                    <Row>
                        <Col sm={12}>
                            <p className='f7'><strong>Penjamin</strong><br />{selectedData ? selectedData.penjamin : ''}</p>
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Row className='pt-3 pb-2'>
                <Col>
                    <Table responsive="sm" size="sm" id='dtListBilling' bordered hover style={{ fontSize: 'smaller' }}>
                        <thead>
                            <tr>
                                <th>Tanggal</th>
                                <th>Ruangan</th>
                                <th>Jenis Layanan</th>
                                <th>DPJP</th>
                                <th>Nama Pelayanan</th>
                                <th>Jumlah</th>
                                <th>Harga</th>
                                <th>Total</th>
                            </tr>
                        </thead>
                    </Table>
                </Col>
            </Row>
            <Row className='bg-warning'>
                <Col xs={6} md={6}>
                    <Row>
                        <Col xs={6} md={7}><p className='f7'><strong>Kode Tarif InaCBG:</strong><br />{nilaiClaim ? `${nilaiClaim.kode_cbg} / ${nilaiClaim.nama_cbg}` : ''}</p></Col>
                        <Col xs={6} md={4}><p className='f7'><strong>Nilai Claim</strong><br />{nilaiClaim ? new Intl.NumberFormat("id-ID", { style: "currency", currency: "IDR" }).format(parseFloat(nilaiClaim.nilai_klaim_inacbg)) : ''}</p></Col>
                    </Row>
                </Col>
                <Col xs={6} md={3}>
                    <Row>
                        <Col sm={12}>
                            <p className='f7'><strong>Total tagihan</strong><br />Rp. {selectedData ? selectedData.billing : ''}</p>
                        </Col>
                    </Row>
                </Col>
                <Col xs={6} md={3}>
                    <Row>
                        <Col sm={12}>
                            <p className='f7'><strong>Jumlah deposit</strong><br />Rp. {selectedData ? selectedData.deposit : ''}</p>
                        </Col>
                    </Row>
                </Col>
                {/* <Col xs={6} md={3}>
                    <Row>
                        <Col sm={12}>
                            <p className='f7'><strong>Total dibayar</strong><br />{selectedData ? new Intl.NumberFormat("id-ID", { style: "currency", currency: "IDR" }).format(parseFloat(selectedData.dibayar)) : ''}</p>
                        </Col>
                    </Row>
                </Col>
                <Col xs={6} md={3}>
                    <Row>
                        <Col sm={12}>
                            <p className='f7'><strong>Sisa tagihan</strong><br />{selectedData ? new Intl.NumberFormat("id-ID", { style: "currency", currency: "IDR" }).format((parseFloat(+selectedData.billing) - (parseFloat(selectedData.dibayar)) - parseFloat(selectedData.deposit))) : ''}</p>
                        </Col>
                    </Row>
                </Col> */}
            </Row>
            <Modal
                show={showDeskripsi}
                onHide={handleCloseDeskripsi}
                backdrop="static"
                size='lg'
            >
                <Modal.Header closeButton>
                    <Modal.Title>Document view</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col md={12}>
                            <iframe id='frameFile' width="750" height="600"></iframe>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        </React.Fragment>
    )
}

export default Billings;